import { EndpointContract } from '../../architecture/ControllerContract';
import { z } from 'zod';
import { assistantChatMessage, chatMessage } from './ChatMessage';
import { chatContext } from './ChatContext';

const processChatMessagesRequest = z
    .object({
        context: chatContext,
        chatMessages: z
            .array(chatMessage)
            .min(1)
            .refine(
                messages =>
                    !(
                        messages[messages.length - 1].role === 'assistant' &&
                        messages[messages.length - 1].content.contentType ===
                            'markdown'
                    )
            )
    })
    .strict();

const processChatMessagesResult = z
    .object({
        assistantChatMessages: z.array(assistantChatMessage)
    })
    .strict();

export const processChatMessages = {
    verb: 'post',
    path: 'process-chat-messages',
    schema: {
        body: processChatMessagesRequest,
        response: {
            200: processChatMessagesResult
        }
    }
} as const satisfies EndpointContract;
